module.exports = "https://images.shiksha.ws/saassets/media/GNBSprite_New.08b0e3c3.svg";